export const en = {
    dashboard: {
        widgets:{
            categories: {
                INTERFACES: "Interfaces",
                DATA: "Historical Data",
                OTHERS: "Others",
            },
            types: {
                DIRECT_VALUE: "Direct Value",
                STICKY_NOTE: "Sticky Note",
                IFRAME: "iFrame",
                CONTROLLER: "Controller",
                COMPLEX_CHART: "Chart",
                TITLE: "Title"
            },
            noData: "No Data to Display",
            configurations: {
                detailsFormTitle: "Configure Widget",
            },
            formsFields: {
                displayName: "Display Name",
                text: "Text",
                entity: "Entity",
                terminal: "Terminal",
                terminalInterface: "Interface",
                intervalHeader: "State Widget Definition",
                addRow: "New State",
                percentage: "Show Percentage Value",
                value: "Value",
                backgroundColor: "Background Color",
                fontColor: "Font Color",
                url: "Website Address",
                chartSeries: {
                    labels: {
                        series: "Series",
                        line: "Line",
                        mergeYAxis: 'Merge Y Axis',
                        forceZero: 'Force Zero',
                        addLine: 'Add Line',
                        addSeries: 'Add Series',
                        addInterface: 'Add Interface',
                        removeLine: 'Remove Line',
                        removeSeries: 'Remove Series',
                        interface: 'Interface',
                        terminalInterface: 'Terminal Interface',
                        entityInterface: 'Entity Interface',
                        terminal: 'Terminal',
                        entity: 'Entity'
                    },
                    type: {
                        label: 'Type',
                        line: 'Line',
                        column: 'Column',
                        step: 'Step'
                    },
                    windowRange: {
                        label: 'Window Range',
                        oneHour: '1 hour',
                        twoHours: '2 hours',
                        sixHours: '6 hours',
                        twelveHours: '12 hours',
                        twentyFourHours: '24 hours',
                        twoDays: '2 days',
                        oneWeek: '1 week',
                        twoWeeks: '2 weeks',
                        oneMonth: '1 month',
                        sixMonths: '6 months', 
                        oneYear: '1 year'
                    },
                    legend: 'Legend',
                    interfaceCategory: 'Interface Category',
                    unit: 'Unit',
                    interfaces: "Interfaces",
                    chooseInterfaceCategory: 'Choose an Interface Category',
                    warningAllValues: 'The aggregator selection that you choose will be applied only in boolean interfaces',
                    resolution: {
                        label: 'Resolution',
                        fiveMinutes: '5m',
                        fifteenMinutes: '15m',
                        oneHour: '1 hour',
                        oneDay: '1 day',
                        oneWeek: '1 week',
                        oneMonth: '1 month'
                    },
                    resolutionAgg: {
                        label: 'Resolution Aggregator',
                        avg: 'Average',
                        max: 'Maximum',
                        min: 'Minimum',
                        sum: 'Sum',
                        allValues: 'All Values'
                    },
                    cumulativeSeries: "Add cumulative line"
                }
            },
        },
        alerts: {
            widget: {
                delete: {
                    title: "Delete Widget",
                    text: "You are about to delete a widget. Are you sure?",
                    success: {
                        title: "Widget Deleted",
                    },
                    error: {
                        title: "Widget Delete Error",
                        text: "Something went wrong. Please try again later",
                    }
                },
                create: {
                    success: {
                        title: "Widget Created",
                    },
                    error: {
                        title: "Widget Created Error",
                        text: "Something went wrong. Please try again later",
                    }
                },
                edit: {
                    success: {
                        title: "Widget Edited",
                    },
                    error: {
                        title: "Widget Edited Error",
                        text: "Something went wrong. Please try again later",
                    }
                },
                duplicate: {
                    title: "Duplicate Widget",
                    text: "You are about to duplicate a widget. Are you sure?",
                    success: {
                        title: "Widget Duplicated",
                    },
                    error: {
                        title: "Widget Duplicate Error",
                        text: "Something went wrong. Please try again later",
                    }
                },
                widgetsMax: {
                    title: "Unable to add widget",
                    text: "Too many widgets already exist in this dashboard",
                },
                controllerWidget: {
                    waitingResponse: "Waiting response..."
                }
            },
            entitiesTree: {
                load: {
                    error: {
                        title: "Load Entities Tree Error",
                        text: "Something went wrong. Please try again later",
                    }
                }
            }

        },
        noData: "You don't have widgets to show",
        error: "Error",
        errors: {
            notAnURL: "This field should be an URL"
        },
        sidePanel: {
            chooseEntities: "Choose Entities"
        },
        options: {
            title: "Create new widget"
        }
    }
};